/** Common citizenship country labels for assisted KYC (web + mobile aligned). */
export const CITIZENSHIP_COUNTRY_OPTIONS = [
  'Australia',
  'New Zealand',
  'United Kingdom',
  'Ireland',
  'United States',
  'Canada',
  'India',
  'China',
  'Hong Kong',
  'Taiwan',
  'Japan',
  'South Korea',
  'Philippines',
  'Vietnam',
  'Thailand',
  'Indonesia',
  'Malaysia',
  'Singapore',
  'Nepal',
  'Sri Lanka',
  'Pakistan',
  'Bangladesh',
  'Afghanistan',
  'Iran',
  'Iraq',
  'Lebanon',
  'Syria',
  'Turkey',
  'Egypt',
  'South Africa',
  'Nigeria',
  'Kenya',
  'Germany',
  'France',
  'Italy',
  'Spain',
  'Netherlands',
  'Belgium',
  'Switzerland',
  'Sweden',
  'Norway',
  'Denmark',
  'Finland',
  'Poland',
  'Ukraine',
  'Russia',
  'Brazil',
  'Argentina',
  'Chile',
  'Colombia',
  'Mexico',
  'Fiji',
  'Samoa',
  'Tonga',
  'Papua New Guinea',
  'Other',
]

/**
 * Passport country of issue for greenID visadvs (ISO-3166 alpha-3; Germany = D).
 * Labels align with citizenship options where possible.
 */
export const PASSPORT_ISSUE_COUNTRY_OPTIONS = [
  { label: 'India', code: 'IND' },
  { label: 'China', code: 'CHN' },
  { label: 'Hong Kong', code: 'HKG' },
  { label: 'Taiwan', code: 'TWN' },
  { label: 'United Kingdom', code: 'GBR' },
  { label: 'Ireland', code: 'IRL' },
  { label: 'United States', code: 'USA' },
  { label: 'Canada', code: 'CAN' },
  { label: 'New Zealand', code: 'NZL' },
  { label: 'Japan', code: 'JPN' },
  { label: 'South Korea', code: 'KOR' },
  { label: 'Philippines', code: 'PHL' },
  { label: 'Vietnam', code: 'VNM' },
  { label: 'Thailand', code: 'THA' },
  { label: 'Indonesia', code: 'IDN' },
  { label: 'Malaysia', code: 'MYS' },
  { label: 'Singapore', code: 'SGP' },
  { label: 'Nepal', code: 'NPL' },
  { label: 'Sri Lanka', code: 'LKA' },
  { label: 'Pakistan', code: 'PAK' },
  { label: 'Bangladesh', code: 'BGD' },
  { label: 'Germany', code: 'D' },
  { label: 'France', code: 'FRA' },
  { label: 'Italy', code: 'ITA' },
  { label: 'Spain', code: 'ESP' },
  { label: 'Netherlands', code: 'NLD' },
  { label: 'Belgium', code: 'BEL' },
  { label: 'Switzerland', code: 'CHE' },
  { label: 'Sweden', code: 'SWE' },
  { label: 'Norway', code: 'NOR' },
  { label: 'Denmark', code: 'DNK' },
  { label: 'Finland', code: 'FIN' },
  { label: 'Poland', code: 'POL' },
  { label: 'Ukraine', code: 'UKR' },
  { label: 'Russia', code: 'RUS' },
  { label: 'Brazil', code: 'BRA' },
  { label: 'Argentina', code: 'ARG' },
  { label: 'Chile', code: 'CHL' },
  { label: 'Colombia', code: 'COL' },
  { label: 'Mexico', code: 'MEX' },
  { label: 'South Africa', code: 'ZAF' },
  { label: 'Nigeria', code: 'NGA' },
  { label: 'Kenya', code: 'KEN' },
  { label: 'Egypt', code: 'EGY' },
  { label: 'Turkey', code: 'TUR' },
  { label: 'Lebanon', code: 'LBN' },
  { label: 'Iran', code: 'IRN' },
  { label: 'Iraq', code: 'IRQ' },
  { label: 'Syria', code: 'SYR' },
  { label: 'Afghanistan', code: 'AFG' },
  { label: 'Fiji', code: 'FJI' },
  { label: 'Samoa', code: 'WSM' },
  { label: 'Tonga', code: 'TON' },
  { label: 'Papua New Guinea', code: 'PNG' },
]
